import { render, staticRenderFns } from "./PaginatorSelector.vue?vue&type=template&id=49e1d0bc&"
import script from "./PaginatorSelector.vue?vue&type=script&lang=js&"
export * from "./PaginatorSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports